/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PlanStatusRefetchQueryVariables = {
    orgRelayId: string;
};
export type PlanStatusRefetchQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"PlanStatusRefetch_org">;
    } | null;
};
export type PlanStatusRefetchQuery = {
    readonly response: PlanStatusRefetchQueryResponse;
    readonly variables: PlanStatusRefetchQueryVariables;
};



/*
query PlanStatusRefetchQuery(
  $orgRelayId: ID!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...PlanStatusRefetch_org
    }
    id
  }
}

fragment PlanStatusRefetch_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      featureStates {
        quotaStatusBanner
        quotaAutopilotStatusCallout
        mixedFreemiumOrgUIState {
          quotaStatusBanner
          autopilotPaused
          moveRangesEnabled
          paymentStatusBadge {
            text
            type
          }
        }
        meetingReliefSettingVisibility
      }
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
            type
            productType
          }
        }
        userMetadata {
          person {
            primaryCalendarId
            id
          }
          trialMetadata {
            trialEndDate
            timeZone
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "quotaStatusBanner",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PlanStatusRefetchQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "PlanStatusRefetch_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PlanStatusRefetchQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgAccountingPeriod",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DateRange",
                                                    "kind": "LinkedField",
                                                    "name": "periodRange",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "minDate",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "maxDate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaMax",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaUsed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enforcementState",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgAccountingPeriod",
                                            "abstractKey": null
                                        },
                                        (v4 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "featureGrid",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FeatureStates",
                                                    "kind": "LinkedField",
                                                    "name": "featureStates",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "quotaAutopilotStatusCallout",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "MixedFreemiumOrgUiState",
                                                            "kind": "LinkedField",
                                                            "name": "mixedFreemiumOrgUIState",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "autopilotPaused",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "moveRangesEnabled",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentStatusBadge",
                                                                    "kind": "LinkedField",
                                                                    "name": "paymentStatusBadge",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "text",
                                                                            "storageKey": null
                                                                        },
                                                                        (v6 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "meetingReliefSettingVisibility",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PaymentStateMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "stateMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PrimaryBillingGroupMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "primaryBillingGroupMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "productType",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "userMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "OrgPerson",
                                                                    "kind": "LinkedField",
                                                                    "name": "person",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "primaryCalendarId",
                                                                            "storageKey": null
                                                                        },
                                                                        (v3 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TrialMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "trialMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "trialEndDate",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "timeZone",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FeatureGrid",
                                            "abstractKey": null
                                        },
                                        (v4 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "a92d5d75021ce68789577971477a4974",
            "id": null,
            "metadata": {},
            "name": "PlanStatusRefetchQuery",
            "operationKind": "query",
            "text": "query PlanStatusRefetchQuery(\n  $orgRelayId: ID!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...PlanStatusRefetch_org\n    }\n    id\n  }\n}\n\nfragment PlanStatusRefetch_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      featureStates {\n        quotaStatusBanner\n        quotaAutopilotStatusCallout\n        mixedFreemiumOrgUIState {\n          quotaStatusBanner\n          autopilotPaused\n          moveRangesEnabled\n          paymentStatusBadge {\n            text\n            type\n          }\n        }\n        meetingReliefSettingVisibility\n      }\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n            type\n            productType\n          }\n        }\n        userMetadata {\n          person {\n            primaryCalendarId\n            id\n          }\n          trialMetadata {\n            trialEndDate\n            timeZone\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '7ef1abd742787942a061830be3a8caa9';
export default node;
